import { h } from "preact";

import { stopPropagation } from "../../../../foundation/utils/legacy";

import Portal from "../../../Portal";
import Menu, { MenuProps } from "../Menu";

import "../style.css";

enum HorizontalAligment {
    Left = "left",
    Right = "right"
}

interface OverlayMenuProps extends MenuProps {
    overlayDivProps?: h.JSX.HTMLAttributes<HTMLDivElement>;
    horizontalAlignment?: HorizontalAligment;
    clickOrigin?: {
        x: number;
        y: number;
    };
    offset?: number;
    onPositionMenu?: (menu: HTMLDivElement) => void;
}

const DEFAULT_OFFSET = 20;

export default function OverlayMenu({
    overlayDivProps = {},
    horizontalAlignment,
    clickOrigin,
    offset = DEFAULT_OFFSET,
    onPositionMenu,
    portalInto,
    ...menuProps
}: OverlayMenuProps) {
    function handleDidRender(node: HTMLElement) {
        const menu = node.children[0] as HTMLDivElement;
        if (!clickOrigin) {
            onPositionMenu?.(menu);
            return;
        }

        const menuRect = menu.getBoundingClientRect();
        const { x, y } = clickOrigin;
        let menuTop = y;
        const leftAlignedMenuLeft = x;
        const rightAlignedMenuLeft = x - menuRect.width;

        let menuLeft = horizontalAlignment === HorizontalAligment.Right ? rightAlignedMenuLeft : leftAlignedMenuLeft;

        if (menuTop + menuRect.height + offset > window.innerHeight) {
            menuTop = window.innerHeight - menuRect.height - offset;
        }

        if (menuLeft + menuRect.width + offset > window.innerWidth) {
            menuLeft = window.innerWidth - menuRect.width - offset;
        } else if (menuLeft < offset) {
            menuLeft = offset;
        }

        menu.style.transform = `translate(${menuLeft}px, ${menuTop}px)`;
    }

    return (
        <Portal into={portalInto} didRender={handleDidRender}>
            <div {...overlayDivProps} class="overlayZplMenuContainer" onMouseDown={stopPropagation}>
                <Menu {...menuProps} overlayPositioned/>
            </div>
        </Portal>
    );
}

export {
    HorizontalAligment as OverlayMenuHorizontalAligment
};
